// src/services/api/supervisionRules.js
// API methods for state-specific supervision rules configuration.

/**
 * Creates supervision rules API methods.
 * Called with the ApiClient instance context (this = ApiClient).
 */
export function createSupervisionRulesMethods() {
  return {
    /**
     * Get supervision state rules for an organization.
     *
     * Xano: GET /supervision-state-rules
     *
     * @param {Object} [filters]
     * @param {string} [filters.organization_id]
     * @param {string} [filters.state]
     * @returns {Promise<Object[]>}
     */
    async getSupervisionStateRules(filters = {}) {
      const queryParams = new URLSearchParams();
      if (filters.organization_id) queryParams.append('organization_id', filters.organization_id);
      if (filters.state) queryParams.append('state', filters.state);
      const qStr = queryParams.toString();
      return this.request(`/supervision-state-rules${qStr ? `?${qStr}` : ''}`, {
        method: 'GET'
      }, 'getSupervisionStateRules');
    },

    /**
     * Create a new state supervision rule set.
     *
     * Xano: POST /supervision-state-rules
     *
     * @param {Object} data
     * @returns {Promise<Object>}
     */
    async createSupervisionStateRules(data) {
      return this.request('/supervision-state-rules', {
        method: 'POST',
        body: JSON.stringify(data)
      }, 'createSupervisionStateRules');
    },

    /**
     * Update state supervision rules.
     *
     * Xano: PATCH /supervision-state-rules/{id}
     *
     * @param {string} id
     * @param {Object} data
     * @returns {Promise<Object>}
     */
    async updateSupervisionStateRules(id, data) {
      return this.request(`/supervision-state-rules/${id}`, {
        method: 'PATCH',
        body: JSON.stringify(data)
      }, 'updateSupervisionStateRules');
    },

    /**
     * Delete state supervision rules.
     *
     * Xano: DELETE /supervision-state-rules/{id}
     *
     * @param {string} id
     * @returns {Promise<null>}
     */
    async deleteSupervisionStateRules(id) {
      return this.request(`/supervision-state-rules/${id}`, {
        method: 'DELETE'
      }, 'deleteSupervisionStateRules');
    },
  };
}
